
<div mat-dialog-title>Edit Multiple Portfolios<button class="close" mat-button title="Cancel" (click)="close()"><i class="material-icons clear">clear</i></button></div>
<mat-dialog-content>
    <div>
        <div style="margin-bottom: 10px;"><strong>{{portfolios.length}} portfolio(s) selected</strong></div>
    </div>
    <irb-inventory-grid
            [style.width] = "'100%'"
            [style.height] = "'120px'"
            [style.minHeight]="'60px'"
            [style.maxHeight]="'210px'"
            [showSideBar] = "false"
            [gridOptions] = "gridOptions"
            [rowData] = 'portfolios'
            (gridReady) = "onGridReady($event)"></irb-inventory-grid>
</mat-dialog-content>
<mat-dialog-actions>
    <button id="closeButton" (click)="close()" class="btn-medium-secondary grey">Cancel</button>
    <button class="btn-medium-primary green" (click)="editSelectedPortfolios()">Continue</button>
</mat-dialog-actions>
